export default __webpack_public_path__ + "static/872-7dd6475a9e533775d06f9bcf756c3a7f.gif";